/**
 * Route Shopify standard cart actions to the full cart page.
 * Cart updates continue to emit from document; no drawer or preview is targeted.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document,
  });

  actions.openCart.configure({
    async handler() {
      window.location.assign(Theme.routes.cart_url || '/cart');
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait until all module scripts have executed.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
